// Auto-generated by generate_stats.py
// Most common words in documents

export const wordData = [
  {
    "word": "document",
    "count": 30472
  },
  {
    "word": "discusses",
    "count": 11071
  },
  {
    "word": "epstein",
    "count": 9923
  },
  {
    "word": "email",
    "count": 7211
  },
  {
    "word": "jeffrey",
    "count": 6526
  },
  {
    "word": "mentions",
    "count": 5441
  },
  {
    "word": "trump",
    "count": 5335
  },
  {
    "word": "including",
    "count": 4772
  },
  {
    "word": "communication",
    "count": 4349
  },
  {
    "word": "may",
    "count": 4200
  },
  {
    "word": "information",
    "count": 4182
  },
  {
    "word": "includes",
    "count": 3966
  },
  {
    "word": "highlights",
    "count": 3818
  },
  {
    "word": "various",
    "count": 3666
  },
  {
    "word": "involving",
    "count": 3559
  },
  {
    "word": "between",
    "count": 3543
  },
  {
    "word": "such",
    "count": 3375
  },
  {
    "word": "com",
    "count": 3311
  },
  {
    "word": "case",
    "count": 3221
  },
  {
    "word": "potential",
    "count": 3091
  },
  {
    "word": "related",
    "count": 2918
  },
  {
    "word": "legal",
    "count": 2880
  },
  {
    "word": "attorney",
    "count": 2874
  },
  {
    "word": "against",
    "count": 2868
  },
  {
    "word": "references",
    "count": 2828
  },
  {
    "word": "york",
    "count": 2756
  },
  {
    "word": "gmail",
    "count": 2731
  },
  {
    "word": "due",
    "count": 2592
  },
  {
    "word": "where",
    "count": 2556
  },
  {
    "word": "include",
    "count": 2526
  },
  {
    "word": "financial",
    "count": 2497
  },
  {
    "word": "contains",
    "count": 2476
  },
  {
    "word": "being",
    "count": 2353
  },
  {
    "word": "dated",
    "count": 2349
  },
  {
    "word": "marked",
    "count": 2270
  },
  {
    "word": "president",
    "count": 2244
  },
  {
    "word": "mentioned",
    "count": 2202
  },
  {
    "word": "political",
    "count": 2128
  },
  {
    "word": "messages",
    "count": 2103
  },
  {
    "word": "sender",
    "count": 2085
  },
  {
    "word": "importance",
    "count": 2076
  },
  {
    "word": "text",
    "count": 2071
  },
  {
    "word": "article",
    "count": 2061
  },
  {
    "word": "suggests",
    "count": 2059
  },
  {
    "word": "confidential",
    "count": 2051
  },
  {
    "word": "report",
    "count": 2040
  },
  {
    "word": "message",
    "count": 1977
  },
  {
    "word": "state",
    "count": 1972
  },
  {
    "word": "privileged",
    "count": 1969
  },
  {
    "word": "highlighting",
    "count": 1944
  },
  {
    "word": "author",
    "count": 1938
  },
  {
    "word": "despite",
    "count": 1936
  },
  {
    "word": "emphasizes",
    "count": 1882
  },
  {
    "word": "while",
    "count": 1881
  },
  {
    "word": "client",
    "count": 1853
  },
  {
    "word": "china",
    "count": 1850
  },
  {
    "word": "more",
    "count": 1849
  },
  {
    "word": "sent",
    "count": 1838
  },
  {
    "word": "during",
    "count": 1805
  },
  {
    "word": "exchange",
    "count": 1798
  },
  {
    "word": "beach",
    "count": 1788
  },
  {
    "word": "high",
    "count": 1761
  },
  {
    "word": "received",
    "count": 1752
  },
  {
    "word": "part",
    "count": 1746
  },
  {
    "word": "federal",
    "count": 1742
  },
  {
    "word": "discussing",
    "count": 1727
  },
  {
    "word": "intended",
    "count": 1723
  },
  {
    "word": "under",
    "count": 1709
  },
  {
    "word": "jeevacation",
    "count": 1707
  },
  {
    "word": "snowden",
    "count": 1704
  },
  {
    "word": "disclosure",
    "count": 1693
  },
  {
    "word": "palm",
    "count": 1685
  },
  {
    "word": "series",
    "count": 1670
  },
  {
    "word": "human",
    "count": 1659
  },
  {
    "word": "victims",
    "count": 1648
  },
  {
    "word": "court",
    "count": 1643
  },
  {
    "word": "clinton",
    "count": 1629
  },
  {
    "word": "individuals",
    "count": 1626
  },
  {
    "word": "challenges",
    "count": 1619
  },
  {
    "word": "government",
    "count": 1611
  },
  {
    "word": "unauthorized",
    "count": 1608
  },
  {
    "word": "regarding",
    "count": 1600
  },
  {
    "word": "involved",
    "count": 1588
  },
  {
    "word": "intelligence",
    "count": 1588
  },
  {
    "word": "issues",
    "count": 1575
  },
  {
    "word": "describes",
    "count": 1574
  },
  {
    "word": "rights",
    "count": 1574
  },
  {
    "word": "focusing",
    "count": 1557
  },
  {
    "word": "israel",
    "count": 1553
  },
  {
    "word": "house",
    "count": 1497
  },
  {
    "word": "public",
    "count": 1478
  },
  {
    "word": "global",
    "count": 1473
  },
  {
    "word": "meeting",
    "count": 1463
  },
  {
    "word": "dershowitz",
    "count": 1461
  },
  {
    "word": "particularly",
    "count": 1458
  },
  {
    "word": "states",
    "count": 1457
  },
  {
    "word": "tax",
    "count": 1446
  },
  {
    "word": "significant",
    "count": 1440
  },
  {
    "word": "need",
    "count": 1432
  },
  {
    "word": "economic",
    "count": 1432
  },
  {
    "word": "others",
    "count": 1428
  },
  {
    "word": "labeled",
    "count": 1393
  },
  {
    "word": "investment",
    "count": 1384
  },
  {
    "word": "error",
    "count": 1383
  },
  {
    "word": "donald",
    "count": 1382
  },
  {
    "word": "prohibited",
    "count": 1374
  },
  {
    "word": "role",
    "count": 1372
  },
  {
    "word": "impact",
    "count": 1363
  },
  {
    "word": "through",
    "count": 1362
  },
  {
    "word": "growth",
    "count": 1361
  },
  {
    "word": "june",
    "count": 1344
  },
  {
    "word": "market",
    "count": 1336
  },
  {
    "word": "using",
    "count": 1327
  },
  {
    "word": "addressee",
    "count": 1325
  },
  {
    "word": "notes",
    "count": 1322
  },
  {
    "word": "allegations",
    "count": 1316
  },
  {
    "word": "media",
    "count": 1313
  },
  {
    "word": "destroy",
    "count": 1306
  },
  {
    "word": "conversation",
    "count": 1298
  },
  {
    "word": "support",
    "count": 1298
  },
  {
    "word": "notify",
    "count": 1291
  },
  {
    "word": "personal",
    "count": 1272
  },
  {
    "word": "march",
    "count": 1267
  },
  {
    "word": "key",
    "count": 1257
  },
  {
    "word": "emphasizing",
    "count": 1250
  },
  {
    "word": "figures",
    "count": 1249
  },
  {
    "word": "data",
    "count": 1227
  },
  {
    "word": "specific",
    "count": 1224
  },
  {
    "word": "sexual",
    "count": 1223
  },
  {
    "word": "social",
    "count": 1215
  },
  {
    "word": "notable",
    "count": 1213
  },
  {
    "word": "military",
    "count": 1210
  },
  {
    "word": "events",
    "count": 1209
  },
  {
    "word": "investigation",
    "count": 1203
  },
  {
    "word": "suggesting",
    "count": 1198
  },
  {
    "word": "unlawful",
    "count": 1194
  },
  {
    "word": "copying",
    "count": 1193
  },
  {
    "word": "act",
    "count": 1187
  },
  {
    "word": "world",
    "count": 1185
  },
  {
    "word": "september",
    "count": 1175
  },
  {
    "word": "january",
    "count": 1168
  },
  {
    "word": "concerns",
    "count": 1164
  },
  {
    "word": "years",
    "count": 1164
  },
  {
    "word": "million",
    "count": 1164
  },
  {
    "word": "possibly",
    "count": 1164
  },
  {
    "word": "november",
    "count": 1159
  },
  {
    "word": "bank",
    "count": 1151
  },
  {
    "word": "law",
    "count": 1150
  },
  {
    "word": "based",
    "count": 1149
  },
  {
    "word": "actions",
    "count": 1143
  },
  {
    "word": "business",
    "count": 1141
  },
  {
    "word": "jee",
    "count": 1137
  },
  {
    "word": "international",
    "count": 1135
  },
  {
    "word": "notice",
    "count": 1133
  },
  {
    "word": "property",
    "count": 1129
  },
  {
    "word": "leading",
    "count": 1126
  },
  {
    "word": "michael",
    "count": 1121
  },
  {
    "word": "office",
    "count": 1120
  },
  {
    "word": "influence",
    "count": 1119
  },
  {
    "word": "university",
    "count": 1118
  },
  {
    "word": "general",
    "count": 1117
  },
  {
    "word": "sex",
    "count": 1113
  },
  {
    "word": "details",
    "count": 1112
  },
  {
    "word": "december",
    "count": 1111
  },
  {
    "word": "foreign",
    "count": 1103
  },
  {
    "word": "inside",
    "count": 1100
  },
  {
    "word": "book",
    "count": 1096
  },
  {
    "word": "made",
    "count": 1087
  },
  {
    "word": "activities",
    "count": 1081
  },
  {
    "word": "number",
    "count": 1078
  },
  {
    "word": "person",
    "count": 1076
  },
  {
    "word": "april",
    "count": 1065
  },
  {
    "word": "questions",
    "count": 1061
  },
  {
    "word": "security",
    "count": 1060
  },
  {
    "word": "united",
    "count": 1056
  },
  {
    "word": "capital",
    "count": 1055
  },
  {
    "word": "july",
    "count": 1050
  },
  {
    "word": "locations",
    "count": 1048
  },
  {
    "word": "jeeitunes",
    "count": 1046
  },
  {
    "word": "several",
    "count": 1044
  },
  {
    "word": "associated",
    "count": 1032
  },
  {
    "word": "american",
    "count": 1032
  },
  {
    "word": "before",
    "count": 1029
  },
  {
    "word": "instructed",
    "count": 1019
  },
  {
    "word": "another",
    "count": 1018
  },
  {
    "word": "concept",
    "count": 1017
  },
  {
    "word": "claims",
    "count": 1010
  },
  {
    "word": "obama",
    "count": 1006
  },
  {
    "word": "february",
    "count": 1000
  },
  {
    "word": "israeli",
    "count": 994
  },
  {
    "word": "times",
    "count": 993
  },
  {
    "word": "confidentiality",
    "count": 992
  },
  {
    "word": "systems",
    "count": 990
  },
  {
    "word": "bill",
    "count": 989
  },
  {
    "word": "should",
    "count": 989
  },
  {
    "word": "interest",
    "count": 987
  },
  {
    "word": "research",
    "count": 985
  },
  {
    "word": "bannon",
    "count": 983
  },
  {
    "word": "contact",
    "count": 982
  },
  {
    "word": "both",
    "count": 981
  }
];
